//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProjectRolesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchProjectRolesQueryParameters = {
  name?: string | null | undefined ;
  projectId?: number | null | undefined ;
  hideSpecialRoles?: boolean | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type PatchProjectRolesQueryParameters = {
  id: number ;
}

export type DeleteProjectRolesQueryParameters = {
  id: number ;
}

export type GetProjectRolesQueryParameters = {
  id: number ;
}

export type GetSuggestedRoleNamesProjectRolesQueryParameters = {
  projectId: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/project-roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProjectRolesClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProjectRoleDto, unknown, Types.CreateProjectRoleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProjectRoleDto, unknown, Types.CreateProjectRoleDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateProjectRoleDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function searchUrl(name?: string | null | undefined, projectId?: number | null | undefined, hideSpecialRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/project-roles?";
if (name !== undefined && name !== null)
    url_ += "Name=" + encodeURIComponent("" + name) + "&";
if (projectId !== undefined && projectId !== null)
    url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
if (hideSpecialRoles !== undefined && hideSpecialRoles !== null)
    url_ += "HideSpecialRoles=" + encodeURIComponent("" + hideSpecialRoles) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfProjectRoleDto, unknown, Types.PagedResultOfProjectRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfProjectRoleDto, unknown, Types.PagedResultOfProjectRoleDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchProjectRolesQueryParameters): QueryKey;
export function searchQueryKey(name?: string | null | undefined, projectId?: number | null | undefined, hideSpecialRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { name, projectId, hideSpecialRoles, offset, limit, sortBy, sortOrder,  } = params[0] as SearchProjectRolesQueryParameters;

    return trimArrayEnd([
        'ProjectRolesClient',
        'search',
        name as any,
        projectId as any,
        hideSpecialRoles as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectRolesClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfProjectRoleDto, TError = unknown>(dto: SearchProjectRolesQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfProjectRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfProjectRoleDto, TError = unknown>(name?: string | null | undefined, projectId?: number | null | undefined, hideSpecialRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfProjectRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfProjectRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfProjectRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let name: any = undefined;
  let projectId: any = undefined;
  let hideSpecialRoles: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ name, projectId, hideSpecialRoles, offset, limit, sortBy, sortOrder,  } = params[0] as SearchProjectRolesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [name, projectId, hideSpecialRoles, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfProjectRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(name, projectId, hideSpecialRoles, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfProjectRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfProjectRoleDto | undefined) => Types.PagedResultOfProjectRoleDto, name?: string | null | undefined, projectId?: number | null | undefined, hideSpecialRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(name, projectId, hideSpecialRoles, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfProjectRoleDto | undefined) => Types.PagedResultOfProjectRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/project-roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'ProjectRolesClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.ProjectRoleDto, unknown, Types.PatchProjectRoleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProjectRoleDto, unknown, Types.PatchProjectRoleDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchProjectRoleDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchProjectRolesQueryParameters & {
  dto: Types.PatchProjectRoleDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ProjectRoleDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchProjectRolesQueryParameters}): UseMutationResult<Types.ProjectRoleDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function deleteUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/project-roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'ProjectRolesClient',
      'delete',
      id as any,
    ]);
}

export function useDeleteMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteProjectRolesQueryParameters

export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteProjectRolesQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/project-roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.ProjectRoleDto, unknown, Types.ProjectRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ProjectRoleDto, unknown, Types.ProjectRoleDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetProjectRolesQueryParameters;

    return trimArrayEnd([
        'ProjectRolesClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectRolesClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.ProjectRoleDto, TError = unknown>(dto: GetProjectRolesQueryParameters, options?: Omit<UseQueryOptions<Types.ProjectRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.ProjectRoleDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.ProjectRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.ProjectRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ProjectRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetProjectRolesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ProjectRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.ProjectRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.ProjectRoleDto | undefined) => Types.ProjectRoleDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ProjectRoleDto | undefined) => Types.ProjectRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getSuggestedRoleNamesUrl(projectId: number): string {
  let url_ = getBaseUrl() + "/api/project-roles/role-names/{projectId}";
if (projectId === undefined || projectId === null)
  throw new Error("The parameter 'projectId' must be defined.");
url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSuggestedRoleNamesDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetSuggestedRoleNamesDefaultOptions() {
  return getSuggestedRoleNamesDefaultOptions;
};
export function setGetSuggestedRoleNamesDefaultOptions(options: typeof getSuggestedRoleNamesDefaultOptions) {
  getSuggestedRoleNamesDefaultOptions = options;
}

export function getSuggestedRoleNamesQueryKey(projectId: number): QueryKey;
export function getSuggestedRoleNamesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { projectId,  } = params[0] as GetSuggestedRoleNamesProjectRolesQueryParameters;

    return trimArrayEnd([
        'ProjectRolesClient',
        'getSuggestedRoleNames',
        projectId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectRolesClient',
        'getSuggestedRoleNames',
        ...params
      ]);
  }
}
export function __getSuggestedRoleNames(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSuggestedRoleNames(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSuggestedRoleNamesQuery<TSelectData = string[], TError = unknown>(dto: GetSuggestedRoleNamesProjectRolesQueryParameters, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetSuggestedRoleNamesQuery<TSelectData = string[], TError = unknown>(projectId: number, options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSuggestedRoleNamesQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let projectId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ projectId,  } = params[0] as GetSuggestedRoleNamesProjectRolesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [projectId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSuggestedRoleNames(context, axiosConfig) : __getSuggestedRoleNames,
    queryKey: getSuggestedRoleNamesQueryKey(projectId),
    ...getSuggestedRoleNamesDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetSuggestedRoleNamesData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], projectId: number) {
  queryClient.setQueryData(getSuggestedRoleNamesQueryKey(projectId),
    updater
  );
}

export function setGetSuggestedRoleNamesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}